
<div v-if="!loading">
  <div v-html="email"></div>
</div>
<div class="d-flex justify-content-center" v-else>
  <loading-spinner></loading-spinner>
</div>
